import { render, staticRenderFns } from "./practicalActivityList.vue?vue&type=template&id=2e29ccf2"
import script from "./practicalActivityList.vue?vue&type=script&lang=js"
export * from "./practicalActivityList.vue?vue&type=script&lang=js"
import style0 from "./practicalActivityList.vue?vue&type=style&index=0&id=2e29ccf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports